import { createSlice } from '@reduxjs/toolkit';
import { UserDto } from '@shared/services/apiService/apiService';

export type CompanyType = {
  title: string;
  logo: string;
};

export type AuthStateType = {
  accessToken: string | null;
  superAdminAccessToken: string | null;
  isLoading: boolean;
  authenticatedUserCompany?: CompanyType;
  authenticatedUser?: UserDto;
};

const storedAccessToken = localStorage.getItem('accessToken');
const superAdminStoredToken = localStorage.getItem('superAdminAccessToken');

const initialState: AuthStateType = {
  authenticatedUserCompany: undefined,
  accessToken: storedAccessToken ? storedAccessToken : null,
  superAdminAccessToken: superAdminStoredToken ? superAdminStoredToken : null,
  isLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.accessToken = action.payload.accessToken;

      state.authenticatedUserCompany = undefined;

      localStorage.setItem('accessToken', action.payload.accessToken);
    },
    signInSuperAdmin: (state, action) => {
      state.superAdminAccessToken = action.payload.accessToken;

      state.authenticatedUserCompany = undefined;

      localStorage.setItem('superAdminAccessToken', action.payload.accessToken);
    },
    signOutSuperAdmin: (state) => {
      state.superAdminAccessToken = null;

      state.authenticatedUserCompany = undefined;
      localStorage.removeItem('superAdminAccessToken');

      return state;
    },
    signOut: (state) => {
      state.accessToken = null;
      state.authenticatedUserCompany = undefined;
      localStorage.removeItem('accessToken');
      return state;
    },
    setAuthenticatedUserCompany: (state, action) => {
      state.authenticatedUserCompany = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setAuthenticatedUser: (state, action) => {
      state.authenticatedUser = action.payload;
    },
  },
});

export const actions = {
  ...authSlice.actions,
};

export const { reducer } = authSlice;
